/** OpenAI enrichment strings (extracted from en.ts to keep it under the size ratchet). */
export const enOpenAi = {
	title: "OpenAI Enrichments",
	subtitle: "Enrich contacts or accounts with GPT4 from OpenAI",
	search: "Search for OpenAI",
	name: "Name",
	type: "Type",
	aiEnrichmentTarget: "Enrichments for",
	aiEnrichmentTargets: {
		contact: "Contact level",
		account: "Account level",
	},
	create: {
		button: "Create new OpenAI Enrichment",
		title: "Create new OpenAI Enrichment",
	},
	update: {
		title: "Update OpenAI Enrichment",
	},
	delete: {
		title: "Delete OpenAI enrichment",
	},
};
